import last from 'lodash/last'
import React, { useEffect } from 'react'
import pclnExpt from '@pcln/experimentation'

import { BundleLoader } from '@pcln/bundle-and-save-components'
import { ItinerarySliceSkeleton, Loader as LoaderCC } from '@pcln/fly-ui-components'
import { usePartner } from '@pcln/whitelabel-components'
import { Box, Flex } from 'pcln-design-system'
import { P, Span } from '@pcln/horizon'
import { Logo as ExpressLogo } from '@pcln/express-deals'

import { translateSearchRequest } from '../../util/translateSearchRequest'

function passengers(travelers) {
  return Object.keys(travelers).reduce((acc, cur) => acc + travelers[cur], 0)
}

const NUM_SKELETON_ITINS = 5

export function Loader({
  variantLoader = false,
  searchRequest,
  ctaTitle = '',
  products,
  isShelves,
  isNotReshopAndWLAndPackages,
}) {
  const isPackageListings = Boolean(products?.length)
  const { tripType, travelers } = translateSearchRequest(searchRequest)
  const whiteLabelPartner = usePartner()
  const passengerCount = passengers(travelers)
  const origin = searchRequest?.slices?.[0]?.originAirport
  const departDate = searchRequest?.slices?.[0]?.travelDate
  let destination
  let returnDate

  if (tripType === 'RT') {
    destination = searchRequest?.slices?.[0]?.destinationAirport
  } else {
    destination = last(searchRequest.slices)?.destinationAirport
  }

  if (tripType !== 'OW') {
    returnDate = last(searchRequest.slices)?.travelDate
  }

  useEffect(() => {
    if (isNotReshopAndWLAndPackages) {
      pclnExpt.fireImpression('AIR_SEARCHES_LOAD_MODIFICATION_WEB')
    }
  }, [isNotReshopAndWLAndPackages])

  let loader = (
    <LoaderCC
      ctaTitle={ctaTitle}
      origin={origin}
      destination={destination}
      departDate={departDate}
      returnDate={returnDate}
      passengerCount={passengerCount}
      tripType={tripType}
    />
  )

  const renderSkeletonItineraries = () => {
    return Array.from({ length: NUM_SKELETON_ITINS }, (_, index) => (
      <Box key={index} mb={3} px={0}>
        <ItinerarySliceSkeleton isShelves={isShelves} />
      </Box>
    ))
  }

  if (variantLoader) {
    return (
      <>
        <div className='border w-full rounded-2xl border-primary-5 p-4'>
          <div className='mb-2'>
            <ExpressLogo
              isTextColorLight={false}
              shouldRenderBadge={false}
              showTrademark={false}
              customHeight={24}
              isPlural={false}
            />
          </div>

          <P textStyle='body2'>
            We negotiate{' '}
            <Span bold textStyle='body2'>
              up to 40% off
            </Span>{' '}
            top airlines. Full details revealed the moment you book.
          </P>
        </div>

        <P className='py-4' textStyle='heading4'>
          Searching Flights to {destination}
        </P>

        {renderSkeletonItineraries()}
      </>
    )
  }

  if (isPackageListings) {
    const subtitle = ctaTitle.includes('Combining') ? ctaTitle : undefined
    loader = <BundleLoader products={products} subtitle={subtitle} mb={2} />

    if (whiteLabelPartner) {
      const whiteLabelBundleSubtitle = whiteLabelPartner.config?.component?.bundleLoader?.subtitle
      loader = (
        <BundleLoader
          useGenericIcons
          products={products}
          subtitle={whiteLabelBundleSubtitle ?? subtitle}
          mb={2}
        />
      )
    }
  }

  return (
    <React.Fragment>
      <Box mt={2} mb={3}>
        <Flex
          flexDirection='column'
          alignItems='center'
          data-autobot-element-id='FLIGHTS_SEARCH_MODERN_LOADING_SCREEN'
          minHeight={!isPackageListings ? '152px' : undefined}
        >
          {loader}
        </Flex>
      </Box>
      {renderSkeletonItineraries()}
    </React.Fragment>
  )
}
